module.exports = __webpack_public_path__ + "static/media/outdoor_02_A.88513125.png";